angular.module('bribac.views.reports', [
  'ngRoute',
  'ui.bootstrap',
  'bribac.translations',
  'bribac.values',
  'bribac.services.api',
  'bribac.components.searchForm',
  'bribac.components.whenLoaded',
  'bribac.components.subjectDetails',
  'bribac.components.agentDetails',
  'bribac.components.organizationDetails',
  'bribac.components.filterIbac',
  'bribac.components.mainGroupSubGroupPicker'
])

    .config(function (
        $routeProvider
    ) {
      $routeProvider.when('/reports', {
        templateUrl: 'reports-view.html',
        controller: 'ReportsViewCtrl',
        controllerAs: '$ctrl',
        resolve: {
          access: function (routeAuth) {
            return routeAuth.requireAuth()
          }
        },
        reloadOnSearch: false
      })
    })

    .controller('ReportsViewCtrl', function (
        $routeParams,
        $scope,
        $filter,
        state,
        $translate,
        api,
        saveBlobAsFile,
        filterUtils,
        KINDS,
        permissions
    ) {
      var $ctrl = this
      // Init
      $ctrl.permissions = permissions
      $ctrl.organization = null

      var ibacTypes = [
        { i18n: "views.singleOrganization.ibacUsageReport", apiMethod: "ibacUsage", hasGroupFilter: false, hasDateFilter: true, hasIbacFilter: true, group: 'ibac' },
        { i18n: "views.singleOrganization.activatedIBacUnits", apiMethod: "activatedIBacUnits", hasGroupFilter: false, hasDateFilter: true, group: 'ibac' },
        { i18n: "views.singleOrganization.currentIbacStatus", apiMethod: "currentIbacStatus", hasGroupFilter: false, hasDateFilter: false, group: 'ibac' },
        { i18n: "views.singleOrganization.ibacAssignmentHistory", apiMethod: "ibacAssignmentHistory", hasGroupFilter: false, hasDateFilter: true, hasIbacFilter: true, group: 'ibac' }
      ]

      var subjectTypes = [
        { i18n: "views.singleOrganization.subjectUsageReport", apiMethod: "subjectUsage", hasGroupFilter: true, hasDateFilter: true, group: 'subject' },
        { i18n: "views.singleOrganization.subjectStatusReport", apiMethod: "subjectStatusReport", hasGroupFilter: true, hasDateFilter: true, group: 'subject' },
        { i18n: "views.singleOrganization.activeOffenders", apiMethod: "activeOffenders", hasGroupFilter: true, hasDateFilter: true, group: 'subject' },
        { i18n: "views.singleOrganization.activeDays", apiMethod: "activeDays", hasGroupFilter: true, hasDateFilter: true, group: 'subject' },
        { i18n: "views.singleOrganization.startOfProgramSubjects", apiMethod: "startOfProgramSubjects", hasGroupFilter: true, hasDateFilter: true, group: 'subject' },
        { i18n: "views.singleOrganization.endOfProgramReport", apiMethod: "endOfProgramSubjects", hasGroupFilter: true, hasDateFilter: true, group: 'subject' },
        { i18n: "views.singleOrganization.scheduleChangesReport", apiMethod: "scheduleChangesReport", hasGroupFilter: true, hasDateFilter: true, group: 'subject' },
        { i18n: "views.singleOrganization.subjectDeviceAssignmentHistory", apiMethod: "subjectDeviceAssignmentHistory", hasGroupFilter: true, hasDateFilter: true, group: 'subject' }
      ]

     $ctrl.reportTypes = {
        'views.reports.groups.subject': subjectTypes,
      }
      $ctrl.reportType = $ctrl.reportTypes['views.reports.groups.subject'][0]

      $ctrl.report = {
        organization: null,
        ibac: null,
        subGroups: []
      }

      $ctrl.hasGroupFilter = true;
      $ctrl.mainGroups = {}

      $ctrl.reportOptions = {
        startDate: {initDate: null},
        endDate: {}
      }

      $ctrl.datePickerOpen = {
        startDate: false,
        endDate: false
      }

      if ($ctrl.permissions.canManageIbacs()) {
          $ctrl.reportTypes['views.reports.groups.ibac'] = ibacTypes
      }


      $scope.$watch('$ctrl.report.startDate', function (newVal) {
        $ctrl.reportOptions.endDate.minDate = newVal
      })

      $scope.$watch('$ctrl.report.endDate', function (newVal) {
        $ctrl.reportOptions.startDate.maxDate = newVal
      })

      $scope.$watch('$ctrl.report.organization', function (newVal) {
        let filter = '';
        if (!!newVal && newVal.id !== -1) {
              filter = '?organization=' + newVal.id
          }
          $ctrl.orgGroupPromise = api.getFilteredByOrg(KINDS.MAIN_GROUP, filter).then(function (request) {
            $ctrl.mainGroups = request.data.list
            $ctrl.report.subGroups = []
            angular.forEach($ctrl.mainGroups, function (mainGroup, i) {
              mainGroup.isChecked = true
              angular.forEach(mainGroup.subGroups, function (subGroup, j) {
                subGroup.isChecked = true
                if ($ctrl.reportType.apiMethod === 'subjectUsage') {
                  $ctrl.report.subGroups.push(subGroup)
                } else {
                  $ctrl.report.subGroups = null
                }
              });
            });
          });
      });


      $ctrl.onReportSubmit = function () {
        var $form = $ctrl.reportForm

        if ($form._submitting) return
        if ($form.$invalid) {
          $form._submitError = 'formErrors.invalidFields'
          return
        }

        $form._submitSuccess = ''
        $form._submitError = ''
        $form._submitting = true

        var parameters = angular.copy($ctrl.report);
        var isoStringMillisecondsRegex = /\.\d{3}/
        if ($ctrl.reportType.hasDateFilter) {
          parameters.startDate = $ctrl.report.startDate.toISOString().replace(isoStringMillisecondsRegex, '')
          parameters.endDate = $ctrl.report.endDate.toISOString().replace(isoStringMillisecondsRegex, '')
        }
        if (parameters.ibac && parameters.ibac.id === -1){
            parameters.ibac = null
        }
        api.report($ctrl.reportType.apiMethod, parameters)
            .finally(function () {
              $form._submitting = false
            })
            .then(
                function success(request) {
                  var blob = new Blob([request.data], {type: request.headers()['content-type']})
                  var fileName = ''
                  if ($ctrl.organization) {
                    fileName += $ctrl.organization.name + ' - '
                  }
                  fileName += $ctrl.reportType.apiMethod +
                      ' - ' + $filter('date')($ctrl.report.startDate, "yyyy-MM-dd") +
                      ' - ' + $filter('date')($ctrl.report.endDate, "yyyy-MM-dd") +
                      '.xls'
                  saveBlobAsFile(blob, fileName)
                  resetForm($form)
                },
                function error(request) {
                  $form._submitError = request.statusText
                }
            )
      }

      $ctrl.toggleDatePicker = function (picker) {
        $ctrl.datePickerOpen[picker] = !$ctrl.datePickerOpen[picker]
      }

      $ctrl.onReportTypeChanged = function (type) {
        if (type.hasGroupFilter) {
          $ctrl.hasGroupFilter = true
          $ctrl.report.subGroups = []
          angular.forEach($ctrl.mainGroups, function (mainGroup, i) {
            angular.forEach(mainGroup.subGroups, function (subGroup, j) {
              if (subGroup.isChecked) {
                $ctrl.report.subGroups.push(subGroup)
              }
            });
          });
        } else {
          $ctrl.hasGroupFilter = false
          $ctrl.report.subGroups = null
        }
      }

      function resetForm($form) {
        if ($form) {
          $form.$setUntouched()
          $form.$setPristine()
        }
      }
    });
